type ErrosDaAPI = Record<string, string[]>;

/**
 * Erro de validação (422, ou 403 no login) já tratado pelo interceptor.
 *
 * Os formulários novos leem `validacoes`, com os campos aninhados. Os antigos
 * foram escritos contra o `HttpErrorResponse` cru e leem `status`,
 * `error.errors` ou `error.error` — sem esses campos aqui, quebravam com
 * TypeError e a validação não aparecia em tela nenhuma. Eles ficam
 * espelhados, com os erros planos que a API mandou, para os dois jeitos
 * funcionarem.
 */
export class ValidacoesFormError extends Error {
  public readonly error: { message?: string; errors: ErrosDaAPI; error: ErrosDaAPI };

  constructor(
    public validacoes: Record<string, string[]>,
    errosDaAPI: ErrosDaAPI = {},
    mensagem?: string,
    public readonly status: number = 422
  ) {
    super(mensagem);
    this.error = { message: mensagem, errors: errosDaAPI, error: errosDaAPI };
  }
}
